<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'deridoc',
  data() {
    return {
      ready: false
    }
  },
  computed: {
    ...mapState(['docs'])
  },
  components: {},
  watch: {
    docs(n, o) {
      if (n === 0 && o !== 0) {
        console.log('ready shready')

        setTimeout(() => {
          const inserted = document.createElement('div')
          inserted.id = 'ready'
          inserted.style.cssText = 'display: none'
          document.body.insertBefore(inserted, document.getElementById('app'))
        }, 500)

      }
    }
  }
}
</script>

<style lang="scss">
$fa-font-path: "~font-awesome/fonts";

@import "~font-awesome/scss/font-awesome.scss";
@import "~bulma/sass/utilities/_all";
@import "~bulma/sass/grid/_all";
@import "~bulma/sass/layout/section";

@import "~bulma/sass/base/_all.sass";
@import "~bulma/sass/elements/button.sass";
@import "~bulma/sass/elements/form.sass";
@import "~bulma/sass/elements/table.sass";
@import "~bulma/sass/elements/content.sass";
@import "~bulma/sass/elements/title.sass";
@import "~bulma/sass/components/tabs.sass";
</style>



// WEBPACK FOOTER //
// App.vue?78f5ef12